<script>
import MyDrawer from "@/components/my-drawer.vue";
import axios from "axios";

export default {
  name: "download-app",
  components: {MyDrawer},

  data(){
    return {
      urlWorkerApk:"", //员工端app
      urlRoomScreenApk:"", //房间屏app

    }
  },

  created(){
    this.getWorkerUrl();
    this.getRoomScreenApk()
  },
  methods:{
    getWorkerUrl(){
      let url = "https://houduan.yffrom.com/yffrom-report/sys/common/apk/yffrom"

      const axios = require('axios');
      axios.get(url).then(res => {
        console.log("获取下载链接",res)
        let {success, result} = res.data;
        if (success && result && result.paramValue) {
          this.urlWorkerApk=res.data.result.paramValue;
        }
      })
    },

    getRoomScreenApk(){
      let url = "https://houduan.yffrom.com/yffrom-report/sys/common/apk/roomScreen"

      const axios = require('axios');
      axios.get(url).then(res => {
        console.log("获取下载链接",res)
        let {success, result} = res.data;
        if (success && result && result.paramValue) {
          this.urlRoomScreenApk=res.data.result.paramValue;
        }
      })
    },

    downLoadApp(){
      this.$refs.drawerDown.showDrawer()
    },

    downL(url){
      const iframe = document.createElement('iframe');
      iframe.src = url;
      iframe.style.display = 'none';
      document.body.appendChild(iframe);
      // 下载后可移除
      setTimeout(() => document.body.removeChild(iframe), 3000);

    },
  },

}
</script>

<template>
<my-drawer ref="drawerDown" title="下载" placement="bottom" :height="300">
  <div class="dflex-col-c">
    <a-button @click="downL(urlWorkerApk)" type="primary" ghost>员工端APP</a-button>
    <a-button @click="downL(urlRoomScreenApk)" type="primary" ghost style="margin-top: 20px">房间屏APP</a-button>
  </div>
</my-drawer>
</template>

<style scoped >

</style>
